interface SpeakerIconProps {
  color?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const SpeakerIcon = (props: SpeakerIconProps) => (
  <svg
    width={props.width || 14}
    height={props.height || 11}
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={props.style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.18754 0.503123C6.32563 0.491582 6.46422 0.518526 6.58793 0.580963C6.71164 0.6434 6.81563 0.73889 6.88837 0.856838C6.96111 0.974786 6.99975 1.11058 7 1.24915L7 1.25006V9.75006L7 9.75097C6.99975 9.88954 6.96111 10.0253 6.88837 10.1433C6.81563 10.2612 6.71164 10.3567 6.58793 10.4192C6.46422 10.4816 6.32563 10.5085 6.18754 10.497C6.04945 10.4855 5.91726 10.4359 5.80562 10.3538C5.79866 10.3487 5.79182 10.3434 5.78513 10.3379L2.92973 8.00005C2.9293 8.00006 2.92886 8.00006 2.92842 8.00006C2.9278 8.00006 2.92718 8.00006 2.92656 8.00006H0.75C0.551089 8.00006 0.360323 7.92105 0.21967 7.78039C0.0790176 7.63974 0 7.44897 0 7.25006V3.75006C0 3.55115 0.0790176 3.36038 0.21967 3.21973C0.360323 3.07908 0.551089 3.00006 0.75 3.00006H2.92975L5.78513 0.662252C5.79182 0.656772 5.79866 0.651466 5.80562 0.64634C5.91725 0.564236 6.04945 0.514663 6.18754 0.503123ZM6 1.77874L3.56261 3.77432C3.387 3.92125 3.165 4.00124 2.93599 4.00006H1V7.00006H2.9249C3.15508 6.99876 3.37866 7.0771 3.55773 7.22181C3.55855 7.22248 3.55937 7.22315 3.56019 7.22381L6 9.22138V1.77874Z"
      fill={props.color || "#2D5BFF"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.77258 3.05478C9.01851 2.92918 9.31969 3.02672 9.44529 3.27264C9.78815 3.94396 10 4.67578 10 5.50006C10 6.31613 9.77907 7.06336 9.44675 7.72459C9.32275 7.97132 9.02221 8.07082 8.77547 7.94681C8.52874 7.82281 8.42924 7.52227 8.55325 7.27553C8.82968 6.72551 9 6.1315 9 5.50006C9 4.85684 8.83685 4.27991 8.55471 3.72748C8.42911 3.48156 8.52666 3.18038 8.77258 3.05478Z"
      fill={props.color || "#2D5BFF"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2479 1.56826C10.4864 1.42904 10.7926 1.50951 10.9318 1.74799C11.5878 2.87176 12 3.88975 12 5.50006C12 7.11277 11.5699 8.14101 10.9336 9.24907C10.7961 9.48853 10.4905 9.57117 10.251 9.43365C10.0115 9.29613 9.92889 8.99052 10.0664 8.75106C10.6476 7.73912 11 6.88361 11 5.50006C11 4.11413 10.6622 3.26961 10.0682 2.25214C9.92897 2.01366 10.0094 1.70747 10.2479 1.56826Z"
      fill={props.color || "#2D5BFF"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.731 0.0786013C11.9637 -0.0699731 12.2729 -0.00172183 12.4215 0.231045C13.3992 1.76282 14 3.24327 14 5.50006C14 7.75454 13.4007 9.26769 12.4188 10.7732C12.268 11.0045 11.9582 11.0697 11.7269 10.9189C11.4956 10.768 11.4303 10.4582 11.5812 10.2269C12.4743 8.85744 13 7.53121 13 5.50006C13 3.47123 12.4758 2.1748 11.5785 0.76908C11.43 0.536314 11.4982 0.227176 11.731 0.0786013Z"
      fill={props.color || "#2D5BFF"}
    />
  </svg>
);
